// Extracted from Blender's subdivision-2 ICO used by meshball() in the asset
// generator. xyz() and the Y-up GLB export cancel, preserving these directions.
// Three's IcosahedronGeometry uses a different orientation.
const holeDirections=[
  [0,0,-1],[.723607302,-.525725305,-.447219521],[-.276388019,-.850649238,-.447219849],
  [-.894426227,0,-.447215617],[-.276388019,.850649238,-.447219849],[.723607302,.525725305,-.447219521],
  [.276388019,-.850649238,.447219849],[-.723607302,-.525725305,.447219521],[-.723607302,.525725305,.447219521],
  [.276388019,.850649238,.447219849],[.894426227,0,.447215617],[0,0,1],
  [-.162455559,-.499995261,-.850654423],[.425322682,-.3090114,-.850654185],[.262868822,-.809011638,-.525737643],
  [.850647867,0,-.525735915],[.425322682,.3090114,-.850654185],[-.525729775,0,-.850651681],
  [-.688189387,-.49999693,-.525736213],[-.162455559,.499995261,-.850654423],[-.688189387,.49999693,-.525736213],
  [.262868822,.809011638,-.525737643],[.951057851,-.309012622,0],[.951057851,.309012622,0],
  [0,-.99999994,0],[.587785602,-.809016705,0],[-.951057851,-.309012622,0],
  [-.587785602,-.809016705,0],[-.587785602,.809016705,0],[-.951057851,.309012622,0],
  [.587785602,.809016705,0],[0,.99999994,0],[.688189387,-.49999693,.525736213],
  [-.262868822,-.809011638,.525737643],[-.850647867,0,.525735915],[-.262868822,.809011638,.525737643],
  [.688189387,.49999693,.525736213],[.162455559,-.499995261,.850654364],[.525729775,0,.850651681],
  [-.425322682,-.3090114,.850654185],[-.425322682,.3090114,.850654185],[.162455559,.499995261,.850654364],
];

export class MeshExtrusion {
  constructor({center=[0,0,0],scale=1,holeDirections:directions=holeDirections}={}) {
    this.center=[...center];this.scale=scale;
    this.innerRadius=.735*scale;
    this.capHeight=(.773+.021+.28-.735)*scale;
    this.bulbs=directions.map(direction=>{
      const length=Math.hypot(...direction);
      const normalized=direction.map(n=>n/length);
      return {direction:normalized,position:[0,0,0],radius:.1*scale,open:normalized[1]<.99};
    });
    this.reset();
  }

  bind(point) {
    const x=point[0]-this.center[0],y=point[1]-this.center[1],z=point[2]-this.center[2];
    const radius=Math.hypot(x,y,z),inverse=radius>1e-10?1/radius:0;
    // Cord boundaries lie near source radius .778. Begin the cap beyond them
    // and keep its shoulder smooth, with a narrower neck inside each opening.
    const t=Math.max(0,Math.min(1,(radius/this.scale-.79)/.10));
    // A broad shoulder and a flat crown avoid stretching each lobe into a cone.
    // The quintic gate keeps the neck slope continuous even after the power.
    const gate=t*t*t*(t*(6*t-15)+10);
    const knotClearance=Math.max(0,Math.min(1,(.99-y*inverse)/.09));
    const cap=Math.pow(gate,.6)*knotClearance;
    return {direction:[x*inverse,y*inverse,z*inverse],cap};
  }

  move(pressure) {
    if(!Number.isFinite(pressure))return;
    this.target=Math.max(0,Math.min(1,pressure));
    this.activity=Math.max(this.activity,Math.abs(this.target-this.pressure));
  }

  release() {this.move(0);}
  reset() {this.pressure=0;this.target=0;this.activity=0;this.updateBulbs();}

  step(dt) {
    if(!Number.isFinite(dt)||dt<=0)return;
    const elapsed=Math.min(dt,2),previous=this.pressure;
    const tau=this.target>this.pressure?.025:.065;
    this.pressure+=(this.target-this.pressure)*(1-Math.exp(-elapsed/tau));
    if(Math.abs(this.pressure-this.target)<.0001)this.pressure=this.target;
    this.activity=Math.max(Math.abs(this.pressure-this.target),Math.abs(this.pressure-previous)/elapsed);
    this.updateBulbs();
  }

  updateBulbs() {
    for(const bulb of this.bulbs){
      // The tied top opening cannot extrude. Other spheres grow while moving
      // outward so their shoulders clear the narrow cords throughout the push.
      const pressure=bulb.open?this.pressure:0;
      const distance=(.52+.38*pressure)*this.scale;
      bulb.radius=(.1+.105*pressure*pressure)*this.scale;
      for(let a=0;a<3;a++)bulb.position[a]=this.center[a]+bulb.direction[a]*distance;
    }
  }

  // Reused poses for an InstancedMesh of unit spheres. Hide them inside the
  // resting body, then expose real spherical overhangs through the net holes.
  getBulbs() {return this.bulbs;}

  sample(binding,out=[0,0,0],capAmount=1) {
    const radius=this.innerRadius+this.capHeight*this.pressure*binding.cap*capAmount,d=binding.direction;
    out[0]=this.center[0]+d[0]*radius;
    out[1]=this.center[1]+d[1]*radius;
    out[2]=this.center[2]+d[2]*radius;
    return out;
  }
}
